import _ from 'lodash';
import InSpecieTransferConstants from '../constants/InSpecieTransferConstants.js';

function isInSpecieEligible(productId) {
    const EligibleInSpecieAccounts = InSpecieTransferConstants.eligibleInSpecieProducts;
    return (productId === EligibleInSpecieAccounts.FirstChoiceSuper ||
        productId === EligibleInSpecieAccounts.FirstChoiceWSSuper ||
        productId === EligibleInSpecieAccounts.FirstChoicePension ||
        productId === EligibleInSpecieAccounts.FirstChoiceWSPension ||
        productId === EligibleInSpecieAccounts.FirstChoiceEmployerSuper);
}

function _getScenarioDetails(inSpecieData) {
    if (_.isEqual(inSpecieData.accountFundingSources, [InSpecieTransferConstants.FundingSources.INTERNAL_NO_TD])) {
        return {
            id: 1,
            inSpecieNotification: 'confirmDetailMessageInternalAccountsOnly',
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: true,
            assetAllocationNotification: null,
            needManualSignApplication: false
        };
    }
    if (_.isEqual(inSpecieData.accountFundingSources, [InSpecieTransferConstants.FundingSources.INTERNAL_TD_AND_NON_TD])) {
        return {
            id: 2,
            inSpecieNotification: 'confirmDetailMessageInternalAccountsOnly',
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (_.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_NO_TD, InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL])) {
        return {
            id: 3,
            inSpecieNotification: 'confirmDetailMessageInternalAccountsOnly',
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (_.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_TD_AND_NON_TD, InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL])) {
        return {
            id: 4,
            inSpecieNotification: 'confirmDetailMessageInternalAccountsOnly',
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (inSpecieData.isLikeForLikeTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_TD_AND_NON_TD, InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 5,
            inSpecieNotification: 'confirmDetailMessageWithExternal',
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (inSpecieData.useAllocationForTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_TD_AND_NON_TD, InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 6,
            inSpecieNotification: 'confirmDetailMessageExternalWithDifferentAllocations',
            showInvestmentOptionAllocation: true,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (inSpecieData.isLikeForLikeTransfer &&  _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_NO_TD, InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 7,
            inSpecieNotification: 'confirmDetailMessageWithExternal',
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: true,
            assetAllocationNotification: null,
            needManualSignApplication: false
        };
    }
    if (inSpecieData.useAllocationForTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_NO_TD, InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 8,
            inSpecieNotification: 'confirmDetailMessageExternalWithDifferentAllocations',
            showInvestmentOptionAllocation: true,
            showAssetAllocationPieChart: true,
            assetAllocationNotification: 'assetAllocationIsCombined',
            needManualSignApplication: false
        };
    }
    if (inSpecieData.useAllocationForTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL, InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 9,
            inSpecieNotification: 'confirmDetailMessageExternalWithDifferentAllocations',
            showInvestmentOptionAllocation: true,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (inSpecieData.isLikeForLikeTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_TD_AND_NON_TD, InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL,
        InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 10,
            inSpecieNotification: 'confirmDetailMessageWithExternal',
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (inSpecieData.useAllocationForTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_TD_AND_NON_TD, InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL,
        InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 11,
            inSpecieNotification: 'confirmDetailMessageExternalWithDifferentAllocations',
            showInvestmentOptionAllocation: true,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (inSpecieData.isLikeForLikeTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_NO_TD, InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL,
        InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 12,
            inSpecieNotification: 'confirmDetailMessageWithExternal',
            showInvestmentOptionAllocation: true,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (inSpecieData.useAllocationForTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_NO_TD, InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL,
        InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 13,
            inSpecieNotification: 'confirmDetailMessageExternalWithDifferentAllocations',
            showInvestmentOptionAllocation: true,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (inSpecieData.isLikeForLikeTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL, InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 14,
            inSpecieNotification: null,
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: true
        };
    }
    if (inSpecieData.isLikeForLikeTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_TD_ONLY, InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 15,
            inSpecieNotification: null,
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: true
        };
    }
    if (inSpecieData.isLikeForLikeTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_TD_ONLY, InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL,
        InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 16,
            inSpecieNotification: null,
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: true
        };
    }
    if (_.isEqual(inSpecieData.accountFundingSources, [InSpecieTransferConstants.FundingSources.INTERNAL_TD_ONLY])) {
        return {
            id: 17,
            inSpecieNotification: null,
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: true
        };
    }
    if (_.isEqual(inSpecieData.accountFundingSources, [InSpecieTransferConstants.FundingSources.INTERNAL_TD_ONLY,
        InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL])) {
        return {
            id: 18,
            inSpecieNotification: null,
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: true
        };
    }
    if (_.isEqual(inSpecieData.accountFundingSources, [InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL])) {
        return {
            id: 19,
            inSpecieNotification: null,
            showInvestmentOptionAllocation: false,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: true
        };
    }
    if (inSpecieData.useAllocationForTransfer && _.isEqual(inSpecieData.accountFundingSources, [
        InSpecieTransferConstants.FundingSources.INTERNAL_TD_ONLY, InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 20,
            inSpecieNotification: 'confirmDetailMessageExternalWithDifferentAllocations',
            showInvestmentOptionAllocation: true,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    if (!inSpecieData.isLikeForLikeTransfer && _.isEqual(inSpecieData.accountFundingSources, [
    InSpecieTransferConstants.FundingSources.INTERNAL_TD_ONLY, InSpecieTransferConstants.FundingSources.INTERNAL_MANUAL,
    InSpecieTransferConstants.FundingSources.EXTERNAL])) {
        return {
            id: 21,
            inSpecieNotification: 'confirmDetailMessageExternalWithDifferentAllocations',
            showInvestmentOptionAllocation: true,
            showAssetAllocationPieChart: false,
            assetAllocationNotification: 'assetAllocationNotAvailable',
            needManualSignApplication: false
        };
    }
    return null;
}

function getIsManualSignApplicationNeeded(isInSpecie, inSpecieData) {
    if (!isInSpecie) {
        return false;
    }

    const scenario = _getScenarioDetails(inSpecieData);
    return _.get(scenario, 'needManualSignApplication', false); 
}

function getInSpecieNotification(isInSpecie, content, inSpecieData) {
    return _getNotification(isInSpecie, content, inSpecieData, 'inSpecieNotification');
}

function getAssetAllocationNotification(isInSpecie, content, inSpecieData) {
    return _getNotification(isInSpecie, content, inSpecieData, 'assetAllocationNotification');
}

function _getNotification(isInSpecie, content, inSpecieData, notificationType) {
    // refer to https://confluence.prod.cba/display/FAM/NOA-XXX+-+%5BIn+specie+transfer%5D+Enable+In+Specie+transfer+functionality
    // this method aims to give result of 5th column (Inspecie Confirm Screen details)
    if (!isInSpecie) {
        return null;
    }

    const scenario = _getScenarioDetails(inSpecieData);
    const contentId = _.get(scenario, notificationType, null);
    return _.get(content, contentId, null);
    
}

function isInvestmentOptionAllocationListVisible(isInSpecie, inSpecieData) {
    // refer to https://confluence.prod.cba/display/FAM/NOA-XXX+-+%5BIn+specie+transfer%5D+Enable+In+Specie+transfer+functionality
    // this method aims to give result of investment option allocation listed of 6th column (Investment Allocation in Confirm Details)

    if (!isInSpecie) {
        // always show investment option allocation list for non-pension or non-inspecie
        return true;
    }

    const scenario = _getScenarioDetails(inSpecieData);
    return _.get(scenario, 'showInvestmentOptionAllocation', false); 
}

function isAssetAllocationPieChartVisible(isInSpecie, inSpecieData) {
    // refer to https://confluence.prod.cba/display/FAM/NOA-XXX+-+%5BIn+specie+transfer%5D+Enable+In+Specie+transfer+functionality
    // this method aims to give result of pie chart display of 6th column (Investment Allocation in Confirm Details)

    if (!isInSpecie) {
        // always show asset allocation pie chart for non-pension or non-inspecie
        return true;
    }

    const scenario = _getScenarioDetails(inSpecieData);
    return _.get(scenario, 'showAssetAllocationPieChart', false); 
}

function getAggregatedAllocationForPieChart(totalAmount, assets, investmentOptions) {
    let aggregatedAllocation = [];
    _.forEach(investmentOptions, function(item) {
        const assetAllocations = _.filter(assets, { investmentOptionId: item.id, rateType: 'B' });
        _.forEach(assetAllocations,
            function(a) {
                let i = _.findIndex(aggregatedAllocation, { assetAllocationCode: a.assetAllocationCode });
                if (i > -1) {
                    let assetAllctAmt = aggregatedAllocation[i].amount +
                        (a.assetAllocationPercent / 100) * item.balance;
                    aggregatedAllocation[i].amount = assetAllctAmt;
                    aggregatedAllocation[i].percent = (assetAllctAmt / totalAmount) * 100;
                } else {
                    aggregatedAllocation.push({
                        assetAllocationCode: a.assetAllocationCode,
                        name: a.description,
                        displayName: a.displayName,
                        amount: (a.assetAllocationPercent / 100) * item.balance,
                        percent: ((a.assetAllocationPercent / 100) * item.balance / totalAmount) * 100
                    });
                }
            });
    });
    return aggregatedAllocation;
}

const InSpecieTransferHelper = {
    isInSpecieEligible: isInSpecieEligible,
    getInSpecieNotification: getInSpecieNotification,
    getAssetAllocationNotification: getAssetAllocationNotification,
    getIsManualSignApplicationNeeded: getIsManualSignApplicationNeeded,
    isInvestmentOptionAllocationListVisible: isInvestmentOptionAllocationListVisible,
    isAssetAllocationPieChartVisible: isAssetAllocationPieChartVisible,
    getAggregatedAllocationForPieChart: getAggregatedAllocationForPieChart
};

export default InSpecieTransferHelper;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/InSpecieTransferHelper.js